import { useEffect, useState } from "react";
import HasPermission from "../../claims/SessionClaims";
import { teacher_permission } from "../../config";
import Sign from "../../models/Sign";
import Vocab from "../../models/Vocab";
import { SplitPill } from "../Misc/SplitPill";
import { fetchVocabsCached } from "../../cachedStaticData";
import SignVocab from "../../models/SignVocab";
import { deleteSignVocab } from "../../services/api";
import { useSignVocabs } from "../../hooks/useALSE";
import SignVocabAddForm from "./SignVocabAddFrom";


interface SignVocabPillsProp {
    isOpen: boolean;
    sign: Sign | null; 
}

export default function SignVocabPills(
    {isOpen, sign}: SignVocabPillsProp
) {
    const [vocabs, setVocabs] = useState<Record<number, Vocab>>({});
    const [signVocabsRefresh, setSignVocabsRefresh] = useState<number>(0);
    const { data: signVocabs, loading: svLoading, error: svError } = useSignVocabs(sign?.sign_id ?? -1, [isOpen, signVocabsRefresh]);
    
    // Reload vocabs
    useEffect(() => {
        if (!isOpen) return;
        
        const fetchData = async() => {
            setVocabs((await fetchVocabsCached()).reduce<Record<number, Vocab>>((acc, item) => {
                acc[item.vocab_id] = item;
                return acc;
            }, {}));
        }
        fetchData();
    }, [isOpen]);
    
    const handleDelete = async (sign_vocab: SignVocab, callback: () => void) => {
        const response = await deleteSignVocab(sign_vocab);
        if (response.ok) {
            callback();
        }
    };

    if (svLoading || svError || signVocabs === null || Object.keys(vocabs).length === 0) {
        return null;
    } else if (signVocabs.length === 0) {
        return <SignVocabAddForm isOpen={isOpen} vocabs={vocabs} signVocabs={signVocabs} sign_id={sign?.sign_id ?? -1} handleAddVocab={() => setSignVocabsRefresh(signVocabsRefresh+1)} />
    }

    if (HasPermission(teacher_permission)) {
        return <div>
            <div className="d-flex flex-wrap my-2">
                {signVocabs.map((vocab, idx) => 
                <SplitPill 
                    key={idx} 
                    left={vocabs[vocab.vocab_id].name}
                    leftTitle="Categoría"
                    right={'📘'.repeat(vocab.level)}
                    rightTitle="Dificultad"
                    button={"🗑️"}
                    handleButtonClick={() => handleDelete(vocab, () => setSignVocabsRefresh(signVocabsRefresh+1))}
                />)}
            </div>
            <SignVocabAddForm isOpen={isOpen} vocabs={vocabs} signVocabs={signVocabs} sign_id={sign?.sign_id ?? -1} handleAddVocab={() => setSignVocabsRefresh(signVocabsRefresh+1)} />
        </div>
    }
    
    return <div className="d-flex flex-wrap my-2">
        {signVocabs.map((vocab, idx) => 
        <SplitPill 
            key={idx}
            left={vocabs[vocab.vocab_id].name}
            right={vocab.level.toString()}
        />)}
    </div>
}